export const applyQueryToPath = (newHref: string): string => {
  if (
    typeof window === 'undefined' ||
    !window ||
    !window.location ||
    !window.location.search
  ) {
    return newHref;
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.delete('error');
  return `${newHref}?${urlSearchParams.toString()}`;
};
